<div [hidden]="!show" class="boundary free-dragging-modal-container">
  <div class="box" appFreeDragging appFreeDraggingHandle>
    <button type="button" class="close" (click)="closeModal()">&times;</button>
    <div class="header-container">
      <div id="rangeTitleContainer">
        <p id="rangesModalTitle"><b> Valid Ranges </b></p>
        <div id="alertIcon" class="swal2-icon swal2-warning swal2-icon-show">
          <div class="swal2-icon-content" style="font-size: 1.75em">!</div>
        </div>
      </div>
    </div>
    <div class="row body-container">
      <div class="col-md-6">
        <p class="sub-title"><b>General Information</b></p>
        <p>
          Modulus of elasticity, E ({{ modulusEUnit }}): {{ modulusEMin }} -
          {{ modulusEMax }}
        </p>
        <p>Poisson’s Ratio, v: 0 - 0.5</p>
        <p>
          Coeff. of thermal Exp. β ({{ coeffThermalExpUnit }}): 0 -
          {{ coeffThermalExpMax }}
        </p>
        <p>Friction Factor: 0 - 1</p>
        <p class="sub-title" style="margin: 15px 0"><b>Load Information</b></p>
        <p>
          Inside Density (<span [innerHTML]="densityUnitFormatted"></span>):
          {{ densityMin }} -
          {{ densityMax }}
        </p>
        <p>
          Outside Density (<span [innerHTML]="densityUnitFormatted"></span>):
          {{ densityMin }} -
          {{ densityMax }}
        </p>
        <p>
          Inside Pressure ({{ pressureUnit }}): {{ insidePressureMin }} -
          {{ insidePressureMax }}
        </p>
        <p>
          Outside Pressure ({{ pressureUnit }}): {{ outsidePressureMin }} -
          {{ outsidePressureMax }}
        </p>
        <p>
          Avg. Temperature ({{ avgTempUnit }}): {{ avgTempMin }} -
          {{ avgTempMax }}
        </p>
      </div>
      <div class="col-md-6">
        <p class="sub-title"><b>Casing Specification</b></p>
        <p>
          Outside Diameter (OD) ({{ outsideDiameterUnit }}):
          {{ outsideDiameterMin }} - {{ outsideDiameterMax }}
        </p>
        <p>
          Nominal Weight ({{ nominalWeightUnit }}): {{ nominalWeightMin }} -
          {{ nominalWeightMax }}
        </p>
        <p>
          Inside Diameter (ID) ({{ insideDiameterUnit }}):
          {{ insideDiameterMin }} - {{ insideDiameterMax }}
        </p>
        <p>SMYS ({{ smysUnit }}): {{ smysMin }} - {{ smysMax }}</p>
        <p>
          Temperature Derating ({{ tempDeratingUnit }}): 0 -
          {{ tempDeratingMax }}
        </p>
        <p>Holliday Limit: 1 - 2</p>
        <p class="sub-title" style="margin: 15px 0"><b>Hole Dimension</b></p>
        <p>Hole ID ({{ holeIdUnit }}): {{ holeIdMin }} - {{ holeIdMax }}</p>
        <p class="sub-title" style="margin: 15px 0">
          <b>Displacement due to Pre-load</b>
        </p>
        <p>
          Δ L Pre-load ({{ deltaLPreloadUnit }}): {{ deltaLPreloadMin }} -
          {{ deltaLPreloadMax }}
        </p>
      </div>
    </div>
  </div>
</div>
